/**
 * @function v3sInterface
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * iframe mit einer Schnittstelle zum WBT-Player.
 * @example
 * <interface width="750" height="500" src="./content/annex/interface/index.html" id="XML01" left="235" top="85"/>
 */
angular.module('v3sWbtPlayerApp').directive('v3sInterface', ["v3sInterfaceService", function (v3sInterfaceService) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            src: '@'
        },
        template: '<iframe src="{{src}}"></iframe>',
        link: function (scope, element, attrs, ctrl, transclude) {
            var iframe = element.find("iframe");

            if (iframe && iframe.length > 0) {
                v3sInterfaceService.setTargetFrame(iframe[0].contentWindow);

                scope.$on('$destroy', function () {
                    v3sInterfaceService.setTargetFrame(null);
                });
            }
        }
    }
}]);